import { useSelector } from "react-redux";
import { SpinnerBlock } from "../common/Spinner";
import { Partnership } from "../../service/api-response/PartnershipListSuccessResponse";
import { PartnershipUpsertForm } from "./PartnershipUpsertForm";
import { GoBackLinkButton } from "../../components/GoBackLinkButton";
import { routes } from "../../appRoutingHelpers";
import { useNavigate, useParams } from "react-router-dom";
import {
  useCreatePartnership,
  useGetMembercardPools,
  useGetMembercardTypes,
  useGetPartnership,
  useUpdatePartnership,
} from "../../service/api";
import * as authSelectors from "../auth/authSelectors";
import { toastr } from "react-redux-toastr";
import { getErrorMessage, useHandleFetchError } from "../../error-handler";

export const PartnershipUpsert = () => {
  const { id } = useParams<{
    id: string | undefined;
  }>();
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const isEdit = !!id;
  const navigate = useNavigate();
  const {
    data: partnership,
    isLoading,
    error: partnershipError,
  } = useGetPartnership(organizationKeyName, isEdit, id);

  const {
    data: memberCardTypes,
    isLoading: isMemberCardTypeLoading,
    error: memberCardTypesError,
  } = useGetMembercardTypes(organizationKeyName);
  const {
    data: memberCardPools,
    isLoading: isMemberCardPoolsLoading,
    error: memberCardPoolsError,
  } = useGetMembercardPools(organizationKeyName);
  const {
    mutateAsync: updatePartnership,
    isLoading: updateIsLoading,
  } = useUpdatePartnership(id);
  const {
    mutateAsync: createPartnership,
    isLoading: creationIsLoading,
  } = useCreatePartnership();

  const onSubmit = async (values: Partnership) => {
    try {
      if (isEdit) {
        await updatePartnership({
          data: values,
          organizationKeyName,
          id,
        });
      } else {
        await createPartnership({
          data: values,
          organizationKeyName,
        });
      }
      toastr.success(
        "Success",
        `Partnership ${isEdit ? "updated" : "created"} successfully`
      );
      navigate(routes.partnershipList(organizationKeyName));
    } catch (error: unknown) {
      const errorMessage = getErrorMessage(error);
      toastr.error("Error", errorMessage);
    }
  };

  useHandleFetchError(partnershipError);
  useHandleFetchError(memberCardTypesError);
  useHandleFetchError(memberCardPoolsError);

  if (isLoading || isMemberCardTypeLoading || isMemberCardPoolsLoading) {
    return <SpinnerBlock />;
  }

  return (
    <div className="container mt-5">
      <GoBackLinkButton
        to={routes.partnershipList(organizationKeyName)}
        text="Back to all partnerships"
      />
      <div className="row">
        <div className="col-12">
          <PartnershipUpsertForm
            onSubmit={(v: any) => onSubmit(v)}
            isUpserting={creationIsLoading || updateIsLoading}
            partnership={partnership || {}}
            memberCardTypes={memberCardTypes || []}
            memberCardPools={memberCardPools || []}
          />
        </div>
      </div>
    </div>
  );
};
